import { styled, Table as TableMui } from "@mui/material"

const TableStyle = styled(TableMui)({
  padding: "1.5rem",
})

export default TableStyle
